import {IconButton} from '@dropbox/dig-components/buttons';
import {Tabs} from '@dropbox/dig-components/tabs';
import {Box} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {SettingsLine} from '@dropbox/dig-icons/assets';
import {analyticsLogger} from 'analytics/analyticsLogger';
import {ROUTE_PATHS} from 'constant';
import {t} from 'i18next';
import {useEffect, useState} from 'react';
import {queryClient} from 'views/QueryClientWrapper';

import {NotificationArchive} from './NotificationArchive';
import {NotificationInbox} from './NotificationInbox';
import styles from './Notifications.module.css';
import {NotificationUpcoming} from './NotificationUpcoming';

const NOTIFICATION_SETTINGS_PATH = `${ROUTE_PATHS.SETTINGS}?t=notifications`;

export const NotificationCenter = ({handleSelection}: {handleSelection: () => void}) => {
  const [selectedTab, setSelectedTab] = useState('inbox');
  const [maxHeight, setMaxHeight] = useState(Math.max(380, window.innerHeight * 0.6 - 100));

  useEffect(() => {
    const handleResize = () => {
      setMaxHeight(Math.max(380, window.innerHeight * 0.6 - 100));
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    analyticsLogger().logEvent('NOTIFICATION_TRAY_OPENED', {tab: selectedTab});
    queryClient.invalidateQueries({queryKey: ['notifications']});
  }, [selectedTab]);

  const handleSettingsClick = () => {
    analyticsLogger().logEvent('NOTIFICATION_SETTINGS_CLICKED', {
      source: 'notification_center',
      tab: selectedTab,
    });
    handleSelection();
  };

  return (
    <Tabs selectedTab={selectedTab} onSelection={setSelectedTab} style={{minHeight: 386}}>
      <Box paddingX="8" className={styles.notificationHeader}>
        <Tabs.Group className={styles.notificationTabsGroup}>
          <Tabs.Tab id="inbox">{t('notification_inbox_tab')}</Tabs.Tab>
          <Tabs.Tab id="upcoming">{t('notification_upcoming_tab')}</Tabs.Tab>
          <Tabs.Tab id="archive">{t('notification_archive_tab')}</Tabs.Tab>
        </Tabs.Group>
        <IconButton
          aria-label={t('notification_settings')}
          href={NOTIFICATION_SETTINGS_PATH}
          variant="transparent"
          size="standard"
          onClick={handleSettingsClick}
          className={styles.notificationSettingsButton}
        >
          <UIIcon src={SettingsLine} />
        </IconButton>
      </Box>
      <Box style={{maxHeight}} overflowY="auto">
        <Tabs.Panel tabId="inbox">
          <NotificationInbox handleSelection={handleSelection} />
        </Tabs.Panel>
        <Tabs.Panel tabId="upcoming">
          <NotificationUpcoming />
        </Tabs.Panel>
        <Tabs.Panel tabId="archive">
          <NotificationArchive handleSelection={handleSelection} />
        </Tabs.Panel>
      </Box>
    </Tabs>
  );
};
